document.querySelectorAll('[data-cxk-newest], [data-cxk-bestsellers]').forEach(async section => {
 if (section.dataset.ready) return;
 section.dataset.ready = 'true';
 const preview = new URLSearchParams(location.search).get('preview_theme_id');
 const link = section.querySelector('[data-catalogue-link]');
 const bestsellers = section.hasAttribute('data-cxk-bestsellers');
 if (preview && link) { const target = new URL(link.href);target.searchParams.set('preview_theme_id', preview);link.href = target.href; }
 try {
  const url = new URL(section.dataset.collectionUrl, location.origin);
  url.searchParams.set('sort_by',bestsellers?'best-selling':'created-descending');url.searchParams.set('section_id','cxk-clarity-browser');
  if (preview) url.searchParams.set('preview_theme_id',preview);
  const response=await fetch(url);if(!response.ok) return;
  const doc=new DOMParser().parseFromString(await response.text(),'text/html');
  const cards=[...doc.querySelectorAll('[data-design]')].slice(0,bestsellers?4:8);
  if(cards.length) section.querySelector('[data-newest-grid], [data-bestseller-grid]').replaceChildren(...cards);
 } catch (_) {}
});
